import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=7e65a240&"
import script from "./BlogCard.vue?vue&type=script&lang=ts&"
export * from "./BlogCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports